import { css, getTextStyles } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';

interface ReceiptLccInformationProps {
  content?: string;
  isExpanded: boolean;
}
const maskedWrapperStyles = (isExpanded: boolean) => css`
  ${!isExpanded &&
  css`
    height: 70px;

    &::after {
      background-image: linear-gradient(rgb(255 255 255 / 0%), #fff 97%);
      bottom: 0;
      content: '';
      height: 100%;
      position: absolute;
      width: 100%;
    }
  `};
  overflow: hidden;
  position: relative;

  & h2 {
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.3;
    margin-bottom: 0.625rem;
  }
`;

const ReceiptLccInformation = ({ content, isExpanded }: ReceiptLccInformationProps) => (
  <div className={maskedWrapperStyles(isExpanded)}>
    <DangerousHtmlContent className={getTextStyles()} content={content} />
  </div>
);

export default ReceiptLccInformation;
